import { render, staticRenderFns } from "./SalesTunnelTable.vue?vue&type=template&id=a0cb02b6"
import script from "./SalesTunnelTable.vue?vue&type=script&lang=js"
export * from "./SalesTunnelTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports